import GetEmailTemplates from '@/graphql/GetEmailTemplates.gql'
import GetDefaultEmailTypes from '@/graphql/GetDefaultEmailTypes.gql'
import GetFinancialEmails from '@/graphql/GetFinancialEmails.gql'
import GetEmailPreview from '@/graphql/GetEmailPreview.gql'
import SaveFinancialEmailConfig from '@/graphql/SaveFinancialEmailConfig.gql'
import SaveFinancialEmailTemplate from '@/graphql/SaveFinancialEmailTemplate.gql'
import RestoreDefaultEmailTemplate from '@/graphql/RestoreDefaultEmailTemplate.gql'
import SaveEmailDestination from '@/graphql/SaveEmailDestination.gql'
import DeleteEmailDestination from '@/graphql/DeleteEmailDestination.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getEmailTemplates ({ dispatch, commit }, { pageNumber = 1, perPage }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetEmailTemplates,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber,
          perPage
        }
      })
      return response.data.getEmailTemplates
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async getDefaultEmailTypes ({ dispatch, commit }, { pageNumber = 1, perPage }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetDefaultEmailTypes,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber,
          perPage
        }
      })
      return response.data.getDefaultEmailTypes
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async getFinancialEmails ({ dispatch }, { search = null } = {}) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetFinancialEmails,
        fetchPolicy: 'no-cache',
        variables: { search }
      })
      return response.data.getFinancialEmails
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async getEmailPreview ({ dispatch }, { emailTypeId }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetEmailPreview,
        fetchPolicy: 'no-cache',
        variables: { emailTypeId }
      })
      return response.data.getEmailPreview
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async saveFinancialEmailConfig ({ dispatch }, { input }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: SaveFinancialEmailConfig,
        variables: { input }
      })
      return response.data.saveFinancialEmailConfig
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async saveFinancialEmailTemplate ({ dispatch }, { input }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: SaveFinancialEmailTemplate,
        variables: { input }
      })
      return response.data.saveFinancialEmailTemplate
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async restoreDefaultEmailTemplate ({ dispatch }, { emailTypeId }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: RestoreDefaultEmailTemplate,
        variables: { emailTypeId }
      })
      return response.data.restoreDefaultEmailTemplate
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async saveEmailDestination ({ dispatch }, { input }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: SaveEmailDestination,
        variables: { input }
      })
      return response.data.saveEmailDestination
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async deleteEmailDestination ({ dispatch }, { id }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: DeleteEmailDestination,
        variables: { id }
      })
      return response.data.deleteEmailDestination
    } catch (err) {
      dispatch('showError', err)
    }
  }
}
